var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.75C5.75736 9.75 4.75 10.7574 4.75 12C4.75 13.2426 5.75736 14.25 7 14.25C8.24264 14.25 9.25 13.2426 9.25 12C9.25 10.7574 8.24264 9.75 7 9.75ZM3.32501 11.25C3.67247 9.53832 5.18578 8.25 7 8.25C8.46569 8.25 9.73498 9.09087 10.3518 10.3165C11.3261 9.63914 12.6739 9.63914 13.6482 10.3165C14.265 9.09087 15.5343 8.25 17 8.25C18.8142 8.25 20.3275 9.53832 20.675 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H20.675C20.3275 14.4617 18.8142 15.75 17 15.75C14.976 15.75 13.3265 14.1465 13.2526 12.1406C12.796 11.0311 11.204 11.0311 10.7474 12.1406C10.6735 14.1465 9.024 15.75 7 15.75C5.18578 15.75 3.67247 14.4617 3.32501 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H3.32501ZM17 9.75C15.7574 9.75 14.75 10.7574 14.75 12C14.75 13.2426 15.7574 14.25 17 14.25C18.2426 14.25 19.25 13.2426 19.25 12C19.25 10.7574 18.2426 9.75 17 9.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeglass);
export default __webpack_public_path__ + "static/media/eyeglass.2de1890e87c3f5363835a3b48023096f.svg";
export { ForwardRef as ReactComponent };